import {Component} from "@angular/core";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {MyreportSearchModel} from "../myreport-search.model";
import {MyreportEntityModel} from "../myreport-entity.model";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";
import {MyreportData} from "../myreport.data";
import {ReportPageComponent} from "../../../framework/entity/report/report-page/report-page.component";

@Component({
    selector: "wbo-myreport-search-page",
    templateUrl: "./myreport-search-page.component.html",
    providers: [provideSearchModel(MyreportSearchModel), provideEntityModel(MyreportEntityModel)]
})
export class MyreportSearchPageComponent extends AbstractSearchPage {
    constructor() {
        super();
    }

    getLinkPath(dataItem: any): string {
        return MyreportData.uuidToResourceName(dataItem.reportUIId);
    }

    getParameter(dataItem: any): any {
        return {[ReportPageComponent.PARAM_MY_REPORT_ID]: dataItem.myreportId};
    }
}
